import { CollectionModel } from '../../../../data-layer/collections/types';
import { pluralize } from '../../../../utils/pluralize';

export const buildMeta = (model: CollectionModel | undefined, canonicalUrl: string) => {
    if (!model) {
        return {};
    }

    return {
        title: model.defaultCollection
            ? 'Яндекс Ритм | Избранное'
            : `${model.displayName} - ${model.numberOfPosts} ${pluralize(
                  model.numberOfPosts,
                  'пост',
                  'поста',
                  'постов',
              )} - ${model.author?.displayName}`,
        description: `Автор ${model.author?.displayName}`,
        links: [{ rel: 'canonical', href: canonicalUrl }],
        openGraph: {
            title: `Яндекс Ритм | Коллекция «${model.displayName}»`,
            description: `Автор ${model.author?.displayName}`,
            image: model?.previewItems[0]
                ? model.previewItems[0].type === 'video'
                    ? model.previewItems[0].media[0]?.firstFrameUrl
                    : model.previewItems[0].media[0]?.url
                : undefined,
        },
    };
};
